import Api from "../../config/ApiConfig";
import * as types from "./types";

const apiUrls = {
    getJobList: "api/v1/jobs",   
}

export const getJobList = (params : types.IJobListParams) => 
    Api.get<types.IDataJob[]>(apiUrls.getJobList + "?taskCode=" + params.taskCode);


    